"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SwitchField = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _formik = require("formik");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _theme = require("../../constants/theme");
var _excluded = ["error", "value", "id"],
  _excluded2 = ["name"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Switch = function Switch(_ref) {
  var error = _ref.error,
    value = _ref.value,
    id = _ref.id,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/_react["default"].createElement(Checkbox, Object.assign({}, props, {
    type: "checkbox",
    id: id
  })), /*#__PURE__*/_react["default"].createElement(Label, {
    hasError: error,
    htmlFor: id
  }, /*#__PURE__*/_react["default"].createElement(Button, null)));
};
var SwitchField = exports.SwitchField = function SwitchField(_ref2) {
  var name = _ref2.name,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name
  }, function (_ref3) {
    var field = _ref3.field,
      _ref3$form = _ref3.form,
      errors = _ref3$form.errors,
      touched = _ref3$form.touched,
      values = _ref3$form.values;
    return /*#__PURE__*/_react["default"].createElement(Switch, Object.assign({
      checked: (0, _formik.getIn)(values, field.name),
      error: touched[field.name] && errors[field.name] ? (0, _formik.getIn)(errors, field.name) : undefined
    }, props, field));
  });
};
var _default = exports["default"] = Switch;
var Checkbox = _styledComponents["default"].input.withConfig({
  displayName: "Switch__Checkbox",
  componentId: "sc-9uuvbq-0"
})(["opacity:0;position:absolute;"]);
var Button = _styledComponents["default"].span.withConfig({
  displayName: "Switch__Button",
  componentId: "sc-9uuvbq-1"
})(["box-shadow:0 0 0 1px var(--border-color),inset 0 0 0 1px var(--border-color);--border-color:", ";position:absolute;top:1px;left:1px;width:22px;height:22px;border-radius:50%;transition:transform 0.2s,left 0.2s;background:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary['5'];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.neutral['5'];
});
var colorHelper = function colorHelper(color, errorColor, background) {
  return (0, _styledComponents.css)(["", " --border-color:", ";", "{--border-color:", ";}"], function (_ref6) {
    var hasError = _ref6.hasError,
      theme = _ref6.theme;
    return hasError && background ? "background: ".concat((0, _theme.getAssignmentColor)(theme, errorColor), ";") : background ? "background: ".concat((0, _theme.getAssignmentColor)(theme, color.assignment, color.step), ";") : '';
  }, function (_ref7) {
    var hasError = _ref7.hasError,
      theme = _ref7.theme;
    return (0, _theme.getAssignmentColor)(theme, !hasError ? color.assignment : errorColor, !hasError ? color.step : undefined);
  }, Button, function (_ref8) {
    var hasError = _ref8.hasError,
      theme = _ref8.theme;
    return (0, _theme.getAssignmentColor)(theme, !hasError ? color.assignment : errorColor, !hasError ? color.step : undefined);
  });
};
var Label = _styledComponents["default"].label.withConfig({
  displayName: "Switch__Label",
  componentId: "sc-9uuvbq-2"
})(["display:flex;align-items:center;justify-content:space-between;width:36px;height:24px;background:", ";border-radius:24px;position:relative;transition:background-color 0.2s;box-shadow:0 0 0 0 var(--border-color),inset 0 0 0 2px var(--border-color);user-select:none;", "{--border-color:", ";}", ":focus + &,", ":hover + &{", "}", ":checked + &{", " ", "{transform:translateX(14px);}}", ":checked:hover + &,", ":checked:focus + &{", "}", ":disabled + &{cursor:not-allowed;", "}", ":checked:disabled + &{", "}"], function (_ref9) {
  var theme = _ref9.theme,
    hasError = _ref9.hasError;
  return !hasError ? (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.input, -2) : theme.colors.negative['30'];
}, Button, function (_ref10) {
  var theme = _ref10.theme,
    hasError = _ref10.hasError;
  return !hasError ? (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.input, -2) : theme.colors.negative['40'];
}, Checkbox, Checkbox, function (_ref11) {
  var theme = _ref11.theme;
  return colorHelper({
    assignment: theme.colorAssignments.input
  }, ['negative', 50]);
}, Checkbox, function (_ref12) {
  var theme = _ref12.theme;
  return colorHelper({
    assignment: theme.colorAssignments.input
  }, ['negative', 50], true);
}, Button, Checkbox, Checkbox, function (_ref13) {
  var theme = _ref13.theme;
  return colorHelper({
    assignment: theme.colorAssignments.input,
    step: 1
  }, ['negative', 60]);
}, Checkbox, colorHelper({
  assignment: ['neutral', 20]
}, ['neutral', 20], true), Checkbox, colorHelper({
  assignment: ['neutral', 30]
}, ['neutral', 30], true));
//# sourceMappingURL=Switch.js.map